import Reveal from './ui/Reveal';
import VideoEmbed from './ui/VideoEmbed';

export default function Hero() {
  return (
    <section className="hero">
      <div className="wrap">
        <Reveal as="span" className="pill">
          <span className="dot closed" /> Live cohort · Enrollment closed
        </Reveal>

        <Reveal as="h1" className="h-hero" delay={1}>
          Become <span className="grad-text">LNG&nbsp;Ready</span>
          <br />
          in 6 weeks.
        </Reveal>

        <Reveal as="p" className="lede" delay={2}>
          Live instruction, demonstrations, and practical guidance to help you build real LNG
          Shipping Competence
        </Reveal>

        <Reveal className="hero-cta" delay={2}>
          <a className="btn btn-primary btn-lg" href="#pricing">
            Join the Program
          </a>
        </Reveal>

        <Reveal as="p" className="hero-date" delay={2}>
          Join the waitlist to be notified when enrollment opens for the next cohort
        </Reveal>

        <Reveal className="hero-media media" delay={3}>
          <VideoEmbed
            src="https://play.gumlet.io/embed/6a66781a5b699d91d60ff39c?background=false&autoplay=false&loop=false&disable_player_controls=false"
            title="LNG Ready program introduction"
          />
        </Reveal>

        <Reveal as="p" className="proof">
          Followed by a global community of more than{' '}
          <span className="underlined">
            <b>80,000</b>
            <span className="underline-mark" aria-hidden="true">
              <svg className="u u1" viewBox="0 0 240 20" preserveAspectRatio="none">
                <path d="M4 12C56 6 146 2 236 1l0 5C146 7 58 11 5 18Z" />
              </svg>
              <svg className="u u2" viewBox="0 0 200 18" preserveAspectRatio="none">
                <path d="M3 11C60 5 130 2 197 1l0 4C130 5 62 9 4 16Z" />
              </svg>
            </span>
          </span>{' '}
          LNG and energy professionals.
        </Reveal>
      </div>
    </section>
  );
}
